// The Bureau des Rumeurs palette, shared by canvas art, the 3D board and (as CSS custom
// properties in tokens.css) the DOM. Red is reserved for accusations and verdicts.

export const BAIZE_DEEP = '#0e2621';
export const BAIZE = '#173b33';
export const BAIZE_LIGHT = '#24544a';
export const MANILA = '#e2b865';
export const MANILA_LIGHT = '#f0d596';
export const MANILA_RULE = '#b98d3f';
export const MANILA_INK = '#5a4118';
export const NEWSPRINT = '#e7e3d6';
export const PHOTO_PAPER = '#ece6d6';
export const INK = '#15171b';
export const INK_SOFT = '#3a3a3a';
export const THREAD = '#e0401f';
export const THREAD_DARK = '#a82a12';
export const VIOLET = '#5b3fa0';
export const BRASS = '#c9a24a';
export const BRASS_INK = '#9a6f1c';

export const FONT_DISPLAY = '"League Gothic", "Arial Narrow", sans-serif';
export const FONT_NEWS = '"Bodoni Moda", "Didot", serif';
export const FONT_TYPE = '"Courier Prime", "Courier New", monospace';
export const FONT_BODY = '"Atkinson Hyperlegible Next Variable", system-ui, sans-serif';
